import currencyApi from "sites-common/service-wrappers/currency-api";
import { useFetchJson } from "../../../fetch-url";

function useCurrencyRates(base) {
  const { data } = useFetchJson(`currency${base}`, currencyApi(base), {});
  if (data) {
    return {
      currencyOptions: Object.keys(data.rates).sort((a, b) => a > b),
      rates: data.rates,
    };
  }
  return { currencyOptions: [base], rates: { [base]: 1 } };
}

export default useCurrencyRates;
